// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ld_sX","right":"styles_right__1K41I"};